// Tuk Models
import { createTukStoreDefaultModel } from './tuk/tuk.store'

const tukContentModels = {
  contentTuk: createTukStoreDefaultModel(),
}

export { tukContentModels }
